import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export default function Subtable({rows}) {
    console.log("rows",rows);
    
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{}}>
            <TableCell style={{fontSize:"20px"}}>user number</TableCell>
            <TableCell style={{fontSize:"20px"}} align="right">user name</TableCell>
            <TableCell style={{fontSize:"20px"}} align="right">phone number</TableCell>
            <TableCell style={{fontSize:"20px"}} align="right">package</TableCell>
            <TableCell style={{fontSize:"20px"}} align="right">start date</TableCell>
             <TableCell style={{fontSize:"20px"}} align="right">end date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
     
          {  rows?.map((rows)=><TableRow
              key={rows?.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell style={{fontSize:"15px",color:"gray"}}  component="th" scope="row">
               {rows?.user?.id}
              </TableCell>
              <TableCell style={{fontSize:"15px",color:"gray"}} align="right">{rows?.user?.name}</TableCell>
              <TableCell style={{fontSize:"15px",color:"gray"}} align="right">{rows?.user?.mobile}</TableCell>
              <TableCell style={{fontSize:"15px",color:"gray"}} align="right">{rows?.package?.name}</TableCell>
              <TableCell style={{fontSize:"15px",color:"gray"}} align="right">{rows?.start_date}</TableCell>
               <TableCell style={{fontSize:"15px",color:"gray"}} align="right">{rows?.end_date}</TableCell>
            </TableRow>)}
     
        </TableBody>
      </Table>
    </TableContainer>
  );
}
